<script>
  import { Router, Route } from "svelte-routing";

  import AuthNavbar from "components/Navbars/AuthNavbar.svelte";
  import FooterSmall from "components/Footers/FooterSmall.svelte";

  import Login from "views/auth/Login.svelte";
  import Register from "views/auth/Register.svelte";

  export let location;
  export let auth;
</script>

<div class="relative min-h-screen">
  <AuthNavbar />
  <main class="relative z-10 min-h-screen flex items-center justify-center px-4 pt-28 pb-32">
    <Router url="auth">
      <Route path="login" component="{Login}" />
      <Route path="register" component="{Register}" />
    </Router>
  </main>
  <FooterSmall absolute={true} />
</div>
